
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runTestCasesWithTimeout} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runTestCasesWithTimeout" in module)) throw new SyntaxError(`export 'runTestCasesWithTimeout' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput, testReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runTestCasesWithTimeout,codeEditor,ok,err,hint,consoleOutput,testReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runTestCasesWithTimeout","codeEditor","ok","err","hint","consoleOutput","testReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_syntax = view(codeEditor("objects:syntax", {
  value: 'const person = {\n  name: "Lara Smith",\n  age: 42,\n  height: 162,\n}\n\nconsole.log(person.name)\nconsole.log(person.age)\nconsole.log(person.height)'
}));
return {demo_syntax};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_syntax"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_syntax) => {
display(consoleOutput(await runWithConsole(demo_syntax)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_syntax"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const demo_mutation = view(codeEditor("objects:mutation", {
  value: 'const pet = {\n  name: "Fluffy",\n  age: 3\n}\n\npet.age = 4              // Feld ändern\npet.color = "schwarz"    // neues Feld hinzufügen\n\nconsole.log(pet)'
}));
return {demo_mutation};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_mutation"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: async (display,consoleOutput,runWithConsole,demo_mutation) => {
display(consoleOutput(await runWithConsole(demo_mutation)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_mutation"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (view,codeEditor) => {
const demo_bracket = view(codeEditor("objects:bracket", {
  value: 'const person = { name: "Lara", age: 42 }\n\nconst whichField = "name"\nconsole.log(person[whichField]) // "Lara" — wie person.name\n\nperson["age"] = 43 // wie person.age = 43\nconsole.log(person)'
}));
return {demo_bracket};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_bracket"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: async (display,consoleOutput,runWithConsole,demo_bracket) => {
display(consoleOutput(await runWithConsole(demo_bracket)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_bracket"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const demo_comp = view(codeEditor("objects:composition", {
  value: 'const course = {\n  name: "JavaScript-Kurs",\n  teachers: [\n    { name: "Anna", subject: "JS-Basics" },\n    { name: "Bob", subject: "Algorithmen" }\n  ],\n  timespan: {\n    start: "2026-07-01",\n    end: "2026-07-14"\n  }\n}\n\nconsole.log(course.name)\nconsole.log(course.teachers[0].name)\nconsole.log(course.timespan.start)'
}));
return {demo_comp};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_comp"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: async (display,consoleOutput,runWithConsole,demo_comp) => {
display(consoleOutput(await runWithConsole(demo_comp)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_comp"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("objects:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (runTestCasesWithTimeout,uebung_code) => {
const uebungResult = runTestCasesWithTimeout({
  code: uebung_code,
  fnName: "analyzeGrades",
  cases: [
    [
      [[{ subject: "Mathe", grade: 1.0 }, { subject: "Bio", grade: 3.0 }]],
      { averageGrade: 2.0, bestSubject: { subject: "Mathe", grade: 1.0 } }
    ],
    [
      [[{ subject: "Deutsch", grade: 2.3 }, { subject: "Englisch", grade: 1.7 }, { subject: "Mathe", grade: 3.3 }]],
      { averageGrade: (2.3 + 1.7 + 3.3) / 3, bestSubject: { subject: "Englisch", grade: 1.7 } }
    ],
    [
      [[{ subject: "Sport", grade: 2.0 }]],
      { averageGrade: 2.0, bestSubject: { subject: "Sport", grade: 2.0 } }
    ],
    [
      [[{ subject: "Geo", grade: 3.0 }, { subject: "Kunst", grade: 1.0 }, { subject: "Latein", grade: 3.0 }, { subject: "Musik", grade: 5.0 }]],
      { averageGrade: 3.0, bestSubject: { subject: "Kunst", grade: 1.0 } }
    ]
  ]
});
return {uebungResult};
},
    inputs: ["runTestCasesWithTimeout","uebung_code"],
    outputs: ["uebungResult"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (display,testReport,uebungResult) => {
display(testReport(uebungResult, "analyzeGrades"));
},
    inputs: ["display","testReport","uebungResult"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
